import {
  CaseListDto,
  CaseStatus,
  PageableListDtoOfCaseListDto,
  QueryFactory,
} from '@lmt/shared-types';
import { useCallback } from 'react';
import { localizeCaseTitle } from './localization/translations';
import i18next from 'i18next';

export type CaseData = CaseListDto & { isClosed: boolean; title: string };

export function useCases(patientId?: number, enabled: boolean = true) {
  return QueryFactory.CaseQuery.useGetCasesQuery(
    {
      patientId: patientId,
    },
    {
      enabled: !!patientId,
      select: useCallback((data: PageableListDtoOfCaseListDto) => {
        return (
          data?.data.map((pCase) => {
            return {
              ...pCase,
              isClosed: pCase.isClosed,
              title:
                localizeCaseTitle(pCase) +
                (pCase.status === CaseStatus.Completed
                  ? ' ' + i18next.t('case_status_postfix.completed')
                  : pCase.status === CaseStatus.Canceled
                    ? ' ' + i18next.t('case_status_postfix.canceled')
                    : ''),
            };
          }) ?? []
        );
      }, []),
    },
  );
}
